import { Controller } from '../utils/controller';
export default class extends Controller {
  static targets = ['arrow', 'content'];
  static requiredTargets = [];

  static classes = ['hide', 'rotate'];
  static requiredClasses = [];

  // TARGETS
  declare arrowTarget: HTMLElement;
  declare contentTarget: HTMLElement;
  declare hasArrowTarget: boolean;
  declare hasContentTarget: boolean;

  // CLASSES
  declare hideClasses: string[];
  declare rotateClass: string;

  collapse() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add(...this.hideClasses);
    }
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.remove(this.rotateClass);
    }
  }

  toggleAccordion(event) {
    event.preventDefault();
    if (this.hasContentTarget) {
      this.hideClasses.forEach((classname) => {
        this.contentTarget.classList.toggle(classname);
      });
    }
    if (this.hasArrowTarget) {
      this.arrowTarget?.classList.toggle(this.rotateClass);
    }
  }
}
